import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'client/hooks/useAppSelector';

const PrivateRoute: React.FC<{
  component: React.ComponentType;
}> = ({ component: Component }) => {
  const isLoggedIn = useAppSelector((state) => state.dashboardAuthReducer.isLoggedIn);
  const currentUser = useAppSelector((state) => state.dashboardAuthReducer.currentUser);

  if (!isLoggedIn) return <Navigate to="/dashboard/login" replace />;
  if (!currentUser || currentUser.role < 3) return <Navigate to="/dashboard/login" replace />;

  return <Component />;
};

export default PrivateRoute;
